<template>
  <div class="service-visit-page">
    <KTCard ref="preview" v-bind:title="'Edit'">
      <template v-slot:title>
        <h3 class="card-label">
          <router-link :to="{ name: 'list-service-locations' }">{{
            $t("MENU.ITEM.SERVICE.LOCATIONS")
          }}</router-link>
          <i class="mr-2"></i>
          <small>{{ $t("LABELS.EDIT") }}</small>
        </h3>
      </template>
      <template v-slot:toolbar>
        <div class="service-visit-page__actions">
          <BackButton />
          <DeleteButton
            v-permission="['service-locations-delete']"
            @onDelete="onDelete"
          />
          <SaveButton
            :isLoading="isLoadingServiceLocation"
            @save="onSave"
          />
        </div>
      </template>
      <template v-slot:body>
        <b-form>
          <ServiceLocationsForm
            v-if="!isPageLoading"
            ref="ServiceLocationsForm"
            :form="form"
          />
          <v-skeleton-loader
            v-if="isPageLoading"
            :loading="isPageLoading"
            type="article"
          />
          <v-overlay :value="!isPageLoading && isLoadingServiceLocation">
            <v-progress-circular indeterminate size="64" />
          </v-overlay>
        </b-form>
      </template>
      <template v-slot:foot>
        <div v-show="_.size(errors) > 0" role="alert" class="alert alert-danger">
          <div class="alert-text" v-for="(error, i) in errors" :key="i">
            {{ error[0] }}
          </div>
        </div>
      </template>
      <template v-slot:toolbarfoot>
        <div class="service-visit-page__actions">
          <BackButton />
          <DeleteButton
            v-permission="['service-locations-delete']"
            @onDelete="onDelete"
          />
          <SaveButton
            :isLoading="isLoadingServiceLocation"
            @save="onSave"
          />
        </div>
      </template>
    </KTCard>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import {
  DELETE_SERVICE_LOCATION,
  FETCH_SERVICE_LOCATION,
  UPDATE_SERVICE_LOCATION
} from "@/modules/service-locations/store/service-locations.module";
import { mapGetters } from "vuex";
import KTCard from "@/view/content/Card.vue";
import SaveButton from "@/view/content/forms/components/SaveButton.vue";
import ServiceLocationsForm from "../components/ServiceLocationsForm.vue";

export default {
  name: "ServiceLocationsEdit",
  components: {
    KTCard,
    SaveButton,
    ServiceLocationsForm
  },
  data() {
    return {
      id: null,
      errors: {},
      isPageLoading: true,
      form: {
        serviceLocationTypeId: null,
        name: null,
        location: null
      }
    };
  },
  computed: {
    ...mapGetters(["isLoadingServiceLocation"])
  },
  mounted() {
    this.id = this.$route.params.id;
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: this.$i18n.t("MENU.ITEM.SERVICE.LOCATIONS"),
        route: { name: "list-service-locations" }
      },
      { title: this.$i18n.t("MENU.ITEM.EDIT") }
    ]);
    this.getServiceLocation();
  },
  methods: {
    getServiceLocation() {
      this.$store
        .dispatch(FETCH_SERVICE_LOCATION, this.id)
        .then(data => {
          this.form = data.data;
          this.isPageLoading = false;
        })
        .catch(response => {
          if (response.status === 404) {
            this.$notify({
              group: "notify",
              type: "error",
              text: "Not Found"
            });
            this.$router.push({ name: "list-service-locations" });
          }
        });
    },
    onSave() {
      const formComponent = this.$refs.ServiceLocationsForm;
      formComponent.$v.form.$touch();
      if (formComponent.$v.form.$anyError) {
        this.$notify({
          group: "notify",
          type: "error",
          title: this.$t("ALERTS.ERROR"),
          text: "Please fill all required fields correctly"
        });
        return;
      }

      this.$store
        .dispatch(UPDATE_SERVICE_LOCATION, {
          id: this.id,
          payload: this.form
        })
        .then(data => {
          this.errors = data.data.errors;
          this.$notify({
            group: "notify",
            type: "success",
            title: "<i class='flaticon2-checkmark'></i> Success",
            text: data.message
          });
          this.$router.push({ name: "list-service-locations" });
        })
        .catch(response => {
          this.errors = response.data.errors;
          this.$notify({
            group: "notify",
            type: "error",
            title: this.$t("ALERTS.ERROR"),
            text: response.data.message
          });
        });
    },
    onDelete() {
      this.$dialog.confirm(this.$t("BUTTON.PLEASE_CONFIRM")).then(() => {
        this.$store
          .dispatch(DELETE_SERVICE_LOCATION, this.id)
          .then(data => {
            this.$notify({
              group: "notify",
              type: "success",
              title: "<i class='flaticon2-checkmark'></i> Success",
              text: data.message
            });
            this.$router.push({ name: "list-service-locations" });
          })
          .catch(response => {
            this.$notify({
              group: "notify",
              type: "error",
              title: this.$t("ALERTS.ERROR"),
              text: response.data.message
            });
          });
      });
    }
  }
};
</script>
